import React, { useState } from 'react'
import { LoginFormImport } from './Import'
const { Form, RoutesMap, InputGroup, SaveButton, useFormik, sidebar, LoginSchema, useNavigate, useDispatch, toast, LuKeyRound, LuUser, SignInTodo, SessionManager, LuEye, LuEyeOff } = LoginFormImport

export default function UserLoginForm(props) {

    const { setTogggle } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [spinner, setSpinner] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const initialValues = {
        user: '',
        password: '',
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: LoginSchema,

        onSubmit: (values, action) => {
            setSpinner(true)
            // localStorage.setItem('user_token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTQsImxvZ2luIjoiVmlwbG92ZS5Hb21lIiwicGFzc3dvcmRIYXNoIjoiMTIzNDU2NzgiLCJmaXJzdE5hbWUiOiJWaXBsb3ZlIiwibGFzdE5hbWUiOiJHb21lIiwiZW1haWwiOiJ2aXBsb3ZlLnRlY2hsZW5lQGdtYWlsLmNvbSIsImltYWdlVXJsIjpudWxsLCJhY3RpdmF0ZWQiOnRydWUsImxhbmdLZXkiOm51bGwsImFjdGl2YXRpb25LZXkiOm51bGwsInJlc2V0S2V5IjpudWxsLCJjcmVhdGVkQnkiOiI1IiwiY3JlYXRlZERhdGUiOm51bGwsInJlc2V0RGF0ZSI6bnVsbCwibGFzdE1vZGlmaWVkQnkiOm51bGwsImxhc3RNb2RpZmllZERhdGUiOm51bGwsImlhdCI6MTcyODI4ODIzMiwiZXhwIjoxNzI4NTQ3NDMyfQ.fQuHe2H5dEDbrzNo5OKxe7p8XWX4D3VkMON5YSyOWKA')
            // console.log(values)
            dispatch(SignInTodo(values)).then((res) => signIn_user(res.payload, action))
        },
    })

    const signIn_user = (res, action) => {
        if (res?.status === 200) {

            SessionManager.setSession('user_token', `Bearer ${res?.data?.data?.token}`, 3)
            SessionManager.setSession('user', res?.data?.data && JSON.stringify(res?.data?.data?.user), 3)

            dispatch(sidebar({ navigate })).then((res1) => sidebar_res(res1.payload))

        } else if (res?.status === 400) {
            setSpinner(false)
            toast.error(res?.data?.message, { position: "bottom-right" })
        } else if (res?.status === 500) {
            setSpinner(false)
            toast.error("Server error!!..", { position: "bottom-right" })
        } else {
            setSpinner(false)
            toast.error("Something went wrong!!..", { position: "bottom-right" })
        }
    }

    const sidebar_res = (res) => {
        if (res?.status === 200) {

            toast.success("SignIn Successfully!!..", { position: "bottom-right" })

            const permission = res?.data?.data?.attributes?.map(val => JSON.parse(val)).flat()
            SessionManager.setSession('permission', JSON.stringify(permission))
            navigate(RoutesMap.DASHBOARD.path)
            setSpinner(false)
        } else {
            toast.error("Something went wrong!!..", { position: "bottom-right" })
            setSpinner(false)
        }
    }


    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>

                <div className='mb-2'>
                    <Form.Label className='fw-medium mb-1' style={{ color: 'grey' }}>{'Username'}</Form.Label>
                    <InputGroup className="" size="md">
                        <InputGroup.Text id="basic-addon1"><LuUser /></InputGroup.Text>
                        <Form.Control
                            className='login-input'
                            placeholder="Enter Your Username"
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            name='user'
                            value={values.user || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </InputGroup>
                    {errors.user && touched.user ? (<span className='text-danger form_label' >{errors.user}</span>) : null}
                </div>

                <div className='mb-2'>
                    <Form.Label className='fw-medium mb-1' style={{ color: 'grey' }}>{'Password'}</Form.Label>
                    <InputGroup className="" size="md">
                        <InputGroup.Text id="basic-addon1"><LuKeyRound /></InputGroup.Text>
                        <Form.Control
                            // type={showPassword ? 'text' : 'password'}
                            type='password'
                            className='login-input'
                            placeholder="Enter Your Password"
                            aria-label="Password"
                            aria-describedby="basic-addon1"
                            name='password'
                            value={values.password || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {/* <InputGroup.Text onClick={() => setShowPassword((prev) => !prev)} id="basic-addon1">
                            {showPassword ? <LuEyeOff /> : <LuEye />}
                        </InputGroup.Text> */}
                    </InputGroup>
                    {errors.password && touched.password ? (<span className='text-danger form_label' >{errors.password}</span>) : null}
                </div>

                {/* <div className='mb-3'>
                    <span style={{ fontSize: '13px', cursor: 'pointer' }}
                    // onClick={() => setTogggle(true)}
                    >Forget Password ?</span>
                </div> */}
                

                <div className="d-flex justify-content-between align-items-center text-muted mt-3">
                    <span style={{ fontSize: '13px' }} className=''>By continuing, you agree to the <u className='text-dark' style={{ cursor: 'pointer' }}> <a style={{ color: 'black' }} href="" target='_blank'>terms of service</a> </u> and <u className='text-dark' style={{ cursor: 'pointer' }}><a style={{ color: 'black' }} href="" target='_blank'>privacy policy</a></u>.</span>
                    <SaveButton button_name='Login' spinner={spinner} />
                </div>

            </Form>
        </>
    )
}
